import {
  featureCreateApi,
  featureDeleteApi,
  featureDetailApi,
  featureEditApi,
  featureListApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { featureActions } from "./actions";

export function* featureSaga() {
  yield takeEveryFsa(featureActions.fetchFeatures.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      featureActions.fetchFeatures,
      featureListApi
    );
  });

  yield takeEveryFsa(
    featureActions.getFeatureDetails.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        featureActions.getFeatureDetails,
        featureDetailApi
      );
    }
  );

  yield takeEveryFsa(
    featureActions.createNewFeature.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        featureActions.createNewFeature,
        featureCreateApi
      );
    }
  );

  yield takeEveryFsa(featureActions.updateFeature.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      featureActions.updateFeature,
      featureEditApi
    );
  });

  yield takeEveryFsa(featureActions.deleteFeature.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      featureActions.deleteFeature,
      featureDeleteApi
    );
  });
}
